import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { BarcodeScannerModal } from "../../../../common/components/forms/inputs/BarcodeField/BarcodeScannerModal";
import { IconButton } from "../../../../common/components/button/iconButton/IconButton";
import { IconType } from "../../../../common/icons/Icon";
import { useGiftVoucherRedeemDialog } from "../hooks/useGiftVoucherRedeemDialog";
import styles from "./GiftVoucherRedeemDialog.module.scss";

interface IGiftVoucherRedeemDialogProps {
  visible: boolean;
  onHide: () => void;
}

export const GiftVoucherRedeemDialog = ({
  visible,
  onHide,
}: IGiftVoucherRedeemDialogProps) => {
  const {
    form,
    isLoading,
    customerOptions,
    areCustomersLoading,
    isScannerVisible,
    openScanner,
    closeScanner,
    handleScanned,
    handleSubmit,
  } = useGiftVoucherRedeemDialog({ visible, onHide });

  return (
    <>
      <AppDialog
        header="Осребряване на ваучер"
        visible={visible}
        className={styles.dialog}
        onHide={onHide}
        tooltip={
          "Свързва ваучера с клиентски профил. Не прехвърля пари — стойността остава " +
          "по ваучера и се усвоява при плащане на касата в този обект."
        }
        dismissableMask={false}
      >
        <FormProvider {...form}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.form_code}>
              <DefaultInputField
                name="code"
                label="Код на ваучера"
                placeholder="10 символа"
                required
                width="100%"
              />
              <IconButton
                iconType={IconType.Camera}
                iconHeight="22px"
                iconWidth="22px"
                className={styles.form_code_scan}
                onClick={openScanner}
                tooltip="Сканирай QR кода"
                ariaLabel="Сканирай QR кода"
              />
            </div>

            <DefaultFormSelectField
              name="userId"
              label="Клиент"
              options={customerOptions}
              isLoading={areCustomersLoading}
              emptyMessage="Няма намерени клиенти."
              filter
              required
              width="100%"
            />

            <p className={styles.form_hint}>
              Ваучерът важи само в обекта, който го е продал.
            </p>

            <div className={styles.form_footer}>
              <DefaultButton
                label="Валидирай"
                type="submit"
                loading={isLoading}
                width="100%"
              />
            </div>
          </form>
        </FormProvider>
      </AppDialog>

      {/*
        The same scanner the cashdesk uses. A scan only FILLS the field: the staff member
        still picks the client, and whether the code is actually usable here is the
        server's call (another studio's voucher is rejected with 32005).
      */}
      <BarcodeScannerModal
        visible={isScannerVisible}
        onHide={closeScanner}
        onScanned={handleScanned}
      />
    </>
  );
};
